export const TRIGGER_TUTORIAL: 'TUTORIALS/TRIGGER_TUTORIAL' = 'TUTORIALS/TRIGGER_TUTORIAL';
export const TRIGGER_TUTORIAL_DELAYED: 'TUTORIALS/TRIGGER_TUTORIAL_DELAYED' = 'TUTORIALS/TRIGGER_TUTORIAL_DELAYED';
export const UN_TRIGGER_TUTORIAL: 'TUTORIALS/UN_TRIGGER_TUTORIAL' = 'TUTORIALS/UN_TRIGGER_TUTORIAL';
export const LOAD_TUTORIALS: 'TUTORIALS/LOAD' = 'TUTORIALS/LOAD';
export const LOAD_TUTORIALS_SUCCESS: 'TUTORIALS/LOAD/SUCCESS' = 'TUTORIALS/LOAD/SUCCESS';
export const LOAD_TUTORIALS_FAILURE: 'TUTORIALS/LOAD/FAILURE' = 'TUTORIALS/LOAD/FAILURE';
export const UPDATE_TUTORIAL_FLAG: 'TUTORIAL/UPDATE_FLAG' = 'TUTORIAL/UPDATE_FLAG';
export const UPDATE_TUTORIAL_FLAG_INSTANTLY: 'TUTORIAL/UPDATE_FLAG/UPDATE_TUTORIAL_FLAG_INSTANTLY' =
	'TUTORIAL/UPDATE_FLAG/UPDATE_TUTORIAL_FLAG_INSTANTLY';
export const UPDATE_TUTORIAL_FLAG_SUCCESS: 'TUTORIAL/UPDATE_FLAG/SUCCESS' = 'TUTORIAL/UPDATE_FLAG/SUCCESS';
export const UPDATE_TUTORIAL_FLAG_FAILURE: 'TUTORIAL/UPDATE_FLAG/FAILURE' = 'TUTORIAL/UPDATE_FLAG/FAILURE';
